import React from "react";
import "../LoanEMICalculators.css";
import { Typography, Grid } from "@mui/material";
import { ArrowForwardRounded } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { ConsolidationLinks } from "../CalculatorsPageLinks";

const LoanConsolidationCalculators = () => {
  const navigate = useNavigate();

  return (
    <div className="pages_box__main_container">
      <div className="pages_box__container">
        <div className="d-flex flex-column gap-3">
          <Typography
            sx={{
              fontSize: {
                xs: 20,
                lg: 35,
                xl: 40,
              },
              fontWeight: 600,
              color: "#59266D",
              lineHeight: { xs: "35px", lg: "40.2px", xl: "49.2px" },
              fontFamily: "Archivo",
            }}
          >
            Debt Consolidation Calculators
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, sm: 18 },
              lineHeight: { xs: "20px", sm: "24px" },
              fontWeight: 400,
              color: "#74589B",
              fontFamily: "Archivo",
            }}
          >
            Debt consolidation is the first step toward financial freedom.
            Whether you're consolidating car loans, home loans, or credit card
            debt, Minemi's calculators help you estimate your savings and
            repayment schedules. Discover the best options to streamline your
            EMIs and reduce your overall burden.
          </Typography>
        </div>

        <div className="pages_cards_grid__container w-100 mt-4 mt-sm-5">
          <Grid container spacing={5}>
            {ConsolidationLinks &&
              ConsolidationLinks.map((item) => (
                <Grid item key={item.id} xs={12} sm={6} md={4}>
                  <button
                    className="calculator_card__box w-100 p-2 py-3 p-sm-3"
                    onClick={() => {
                      navigate(`${item.link}`);
                    }}
                  >
                    <div className="d-flex flex-row gap-2 align-items-center justify-content-between">
                      <p
                        style={{
                          fontSize: 16,
                          color: "#1f1f1f",
                          lineHeight: "20px",
                          fontWeight: 500,
                          fontFamily: "Archivo",
                        }}
                        className="calculator_name m-0"
                      >
                        {item.calculatorName}
                      </p>
                      <div className="rounded">
                        <ArrowForwardRounded sx={{ color: "#59266D" }} />
                      </div>
                    </div>
                  </button>
                </Grid>
              ))}
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default LoanConsolidationCalculators;
